import Address from '../features/address/Components/Address'

const AddressPage = () => {
  document.title = "Your Saved Address";
  return <Address />
}

export default AddressPage